export default class Trim {
  filter(value) {
    return value.trim();
  }
}